export const LANE = 'LANE';
export const GRID = 'GRID';

export const isDisplayedAsLane = (displayAs) => displayAs === LANE;
